// Stays here in the shell, a wrapper around the fed init
import { Store } from 'vuex';
import { logger } from '@app/logger';
import { addFederationRoutes } from '@src/app/router';

export async function initializeWalletFederation(store: Store<unknown>): Promise<void> {
    try {
        const walletModule = await import('./src/initializeFederation');

        walletModule.initializeWalletFederation({
            store,
            routes: {
                addBasicRoutes: addFederationRoutes,
            },
        });
    } catch (error) {
        logger.error(error as Error);
    }
}
